import apiClient from "@/services/ApiClient";

export function deleteActions(path) {
  const deleteItems = ids => apiClient.delete(`${path}/${ids}`);

  return { deleteItems };
}
